import React from 'react';
import PropTypes from 'prop-types';

const ProgressBar = props => (
  <div
    style={{
      opacity: props.isFinished ? 0 : 1,
      pointerEvents: 'none',
      transition: `opacity ${props.animationDuration}ms linear`,
    }}
  >
    <div
      style={{
        background: props.color,
        height: 3,
        left: 0,
        marginLeft: `${(-1 + props.progress) * 100}%`,
        position: 'fixed',
        top: 0,
        transition: `margin-left ${props.animationDuration}ms linear`,
        width: '100%',
        zIndex: 1031,
      }}
    >
      <div
        style={{
          boxShadow: `0 0 10px ${props.color}, 0 0 5px ${props.color}`,
          display: 'block',
          height: '100%',
          opacity: 1,
          position: 'absolute',
          right: 0,
          transform: 'rotate(3deg) translate(0px, -4px)',
          width: 100,
        }}
      />
    </div>
  </div>
);

ProgressBar.propTypes = {
  color: PropTypes.string.isRequired,
  isFinished: PropTypes.bool,
  animationDuration: PropTypes.number,
  progress: PropTypes.number,
};

export default ProgressBar;
